/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IConfirmRegulationObligationMutationVariables = Types.Exact<{
  input: Types.IConfirmRegulationObligationInput;
}>;

export type IConfirmRegulationObligationMutation = {
  __typename?: 'Mutation';
  confirmRegulationObligation: {
    __typename?: 'InternalRegulationObligation';
    id: string;
    title?: string | null;
    reviewStatus?: Types.IInternalRegulationObligationReviewStatus | null;
    mappingsReviewStatus?: Types.IInternalRegulationObligationReviewStatus | null;
    fragment?: {
      __typename?: 'InternalRegulationFragmentConnection';
      edges: Array<{
        __typename?: 'InternalRegulationFragmentEdge';
        node: { __typename?: 'InternalRegulationFragment'; id: string; title?: string | null };
      }>;
    } | null;
  };
};

export const ConfirmRegulationObligationDocument = gql`
  mutation ConfirmRegulationObligation($input: ConfirmRegulationObligationInput!) {
    confirmRegulationObligation(input: $input) {
      id
      title
      reviewStatus
      mappingsReviewStatus
      fragment {
        edges {
          node {
            id
            title
          }
        }
      }
    }
  }
`;
export type IConfirmRegulationObligationMutationFn = Apollo.MutationFunction<
  IConfirmRegulationObligationMutation,
  IConfirmRegulationObligationMutationVariables
>;

/**
 * __useConfirmRegulationObligationMutation__
 *
 * To run a mutation, you first call `useConfirmRegulationObligationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmRegulationObligationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmRegulationObligationMutation, { data, loading, error }] = useConfirmRegulationObligationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmRegulationObligationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IConfirmRegulationObligationMutation,
    IConfirmRegulationObligationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<IConfirmRegulationObligationMutation, IConfirmRegulationObligationMutationVariables>(
    ConfirmRegulationObligationDocument,
    options,
  );
}
export type ConfirmRegulationObligationMutationHookResult = ReturnType<typeof useConfirmRegulationObligationMutation>;
export type ConfirmRegulationObligationMutationResult = Apollo.MutationResult<IConfirmRegulationObligationMutation>;
export type ConfirmRegulationObligationMutationOptions = Apollo.BaseMutationOptions<
  IConfirmRegulationObligationMutation,
  IConfirmRegulationObligationMutationVariables
>;
